export default (required = false) => ({
    disabled: false,
    value: '',
    required,
    error: false,
    validate() {
        this.error = this.required && this.value.length === 0;
    }
});